import { Input } from "../ui/input";
import { Button } from "../ui/button";
import { Plus, X } from "lucide-react";

function ActionRow({ action, onUpdate, onRemove, testId, triggerLabel }) {
  return (
    <div className="bg-black/20 rounded-lg p-2 space-y-1.5" data-testid={testId}>
      <div className="flex items-center gap-1.5">
        <Input placeholder="Name" value={action.name || ""} onChange={(e) => onUpdate({ ...action, name: e.target.value })} className="bg-black/30 border-white/10 h-7 text-xs flex-1" />
        <Input placeholder={triggerLabel} value={action[triggerLabel === "Trigger" ? "trigger" : "action_cost"] || ""} onChange={(e) => onUpdate({ ...action, [triggerLabel === "Trigger" ? "trigger" : "action_cost"]: e.target.value })} className="bg-black/30 border-white/10 h-7 text-xs w-24" />
        <Input placeholder="Traits" value={action.traits || ""} onChange={(e) => onUpdate({ ...action, traits: e.target.value })} className="bg-black/30 border-white/10 h-7 text-xs w-24" />
        <button onClick={onRemove} className="text-[#f1e0c5]/30 hover:text-[#D90429] shrink-0"><X className="w-3.5 h-3.5" /></button>
      </div>
      <textarea
        placeholder="Effect"
        value={action.effect || ""}
        onChange={(e) => onUpdate({ ...action, effect: e.target.value })}
        rows={2}
        className="w-full bg-black/30 border border-white/10 rounded-lg p-1.5 text-xs resize-none"
      />
    </div>
  );
}

export default function SheetActionsSection({ character, patchChar }) {
  const activities = character.actions_activities || [];
  const reactions = character.free_actions_reactions || [];

  const updateList = (key, list, idx, value) => {
    patchChar({ [key]: list.map((a, i) => (i === idx ? value : a)) });
  };
  const removeFromList = (key, list, idx) => patchChar({ [key]: list.filter((_, i) => i !== idx) });
  const addToList = (key, list) => patchChar({ [key]: [...list, { name: "", traits: "", effect: "" }] });

  return (
    <div className="space-y-4">
      <div>
        <p className="text-[10px] uppercase text-[#f1e0c5]/40 mb-1.5">Actions &amp; Activities</p>
        <div className="space-y-1.5">
          {activities.map((a, idx) => (
            <ActionRow key={idx} testId={`action-activity-${idx}`} action={a} triggerLabel="Actions" onUpdate={(v) => updateList("actions_activities", activities, idx, v)} onRemove={() => removeFromList("actions_activities", activities, idx)} />
          ))}
          <Button data-testid="add-action-activity" onClick={() => addToList("actions_activities", activities)} size="sm" variant="secondary" className="rounded-full gap-1.5 h-7 text-xs"><Plus className="w-3 h-3" /> Add Action</Button>
        </div>
      </div>
      <div>
        <p className="text-[10px] uppercase text-[#f1e0c5]/40 mb-1.5">Free Actions &amp; Reactions</p>
        <div className="space-y-1.5">
          {reactions.map((a, idx) => (
            <ActionRow key={idx} testId={`free-reaction-${idx}`} action={a} triggerLabel="Trigger" onUpdate={(v) => updateList("free_actions_reactions", reactions, idx, v)} onRemove={() => removeFromList("free_actions_reactions", reactions, idx)} />
          ))}
          <Button data-testid="add-free-reaction" onClick={() => addToList("free_actions_reactions", reactions)} size="sm" variant="secondary" className="rounded-full gap-1.5 h-7 text-xs"><Plus className="w-3 h-3" /> Add Reaction</Button>
        </div>
      </div>
    </div>
  );
}
